module.exports = __webpack_public_path__ + "static/PTMono-Regular-ded295e133401fa463f79f5af5be8160.woff";